import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  layer: {
    position: "absolute",
    left: "-50%",
    zIndex: -1
  },
  "@media (max-width: 720px)": {
    layer: {
      left: "-100%"
    }
  }
});

function ScheduleUnderlayer() {
  const classes = useStyles();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="857"
      height="572"
      className={classes.layer}
      viewBox="0 0 857 572"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path
          fill="#4938CB"
          d="M497.674 94.302c-54.91-1.901-107.209-19.591-157.153-38.94-49.944-19.35-99.41-40.79-153.014-51.04-34.468-6.598-73.895-7.53-101.673 10.91-26.73 17.743-35.364 48.372-40.011 76.797-3.493 21.387-5.544 43.888 4.025 63.911 6.644 13.895 18.445 25.577 26.578 38.888 28.393 46.327 8.353 103.442-22.447 148.679-14.429 21.212-31.18 41.455-42.313 64.04C.534 430.13-4.6 456.01 5.19 479.086c9.659 22.833 32.653 39.985 57.614 52.054 50.604 24.463 110.284 31.478 168.474 35.448 128.82 8.788 258.332 4.985 387.494 1.174 47.795-1.416 95.81-2.84 142.831-10.22 26.115-4.09 53.073-10.606 72.034-26.28 24.065-19.918 30.034-53.646 13.905-78.624-27.05-41.896-101.84-52.275-120.741-97.26-10.411-24.744.28-52.313 15.408-75.26 32.44-49.244 86.819-92.428 89.682-148.71 1.974-38.637-24.171-77.366-64.593-95.654-42.373-19.167-101.118-16.758-132.381 14.978-32.19 32.675-88.756 45.244-137.242 43.57z"
        ></path>
      </g>
    </svg>
  );
}

export default ScheduleUnderlayer;
